export const addressSeries = [
    {
        "title": "全部",
        "value": "",
        "active": true
    },
    {
        "title": "北京",
        "value": "1",
        "active": false
    },
    {
        "title": "天津",
        "value": "2",
        "active": false
    },
    {
        "title": "河北",
        "value": "3",
        "active": false
    },
    {
        "title": "山东",
        "value": "4",
        "active": false
    },
    {
        "title": "陕西",
        "value": "5",
        "active": false
    }
]

export const dataSourceSeries = [
    {
        "title": "全部",
        "value": "",
        "active": true
    },
    {
        "title": "能建",
        "value": "1",
        "active": false
    },
    {
        "title": "交建",
        "value": "2",
        "active": false
    }
]

export const timeSeries = [
    {
        "title": "全部",
        "value": "",
        "active": true
    },
    {
        "title": "近一周",
        "value": "1",
        "active": false
    },
    {
        "title": "近一个月",
        "value": "2",
        "active": false
    },
    {
        "title": "近三个月",
        "value": "3",
        "active": false
    },
    {
        "title": "近半年",
        "value": "4",
        "active": false
    }
]
export const pubTimeSeries = [
    {
        "title": "全部",
        "value": "",
        "active": true
    },
    {
        "title": "近一周",
        "value": "1",
        "active": false
    },
    {
        "title": "近一个月",
        "value": "2",
        "active": false
    },
    {
        "title": "近三个月",
        "value": "3",
        "active": false
    },
    {
        "title": "近半年",
        "value": "4",
        "active": false
    }
]
export const gatherStatusSeries = [
    {
        "title": "全部",
        "value": "",
        "active": true
    },
    {
        "title": "detail",
        "value": "detail",
        "active": false
    },
    {
        "title": "list",
        "value": "list",
        "active": false
    },
    {
        "title": "content",
        "value": "content",
        "active": false
    }
]